import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';
import clsx from 'clsx';

import { LOOK, TotalSumInput } from 'components/_basic/TotalSumInput';

import { concatWithDot } from 'helpers/string';

import { ITotalRowComponentProps } from './types';

import styles from './TotalRowComponent.module.scss';

export const TotalRowComponent: React.FC<ITotalRowComponentProps> = ({
  columnValues,
  firstColumnWidth,
  totalRowTitle = '',
  name,
  noNeedName = false,
  disabled = false,
  marginBottomSize = 'small',
}) => {
  const { t } = useTranslation();

  return (
    <Grid container wrap="nowrap" gap={2} className={clsx(styles.container, styles[`${marginBottomSize}MarginBottom`])}>
      <Grid
        item
        sx={{ width: firstColumnWidth, minWidth: firstColumnWidth }}
        className={clsx(styles.summaryTitle, styles.sticky, { [styles.disabled]: disabled })}
      >
        {totalRowTitle || t('total')}
      </Grid>
      <Grid item xs>
        <Grid container spacing={1} columns={columnValues.length} wrap="nowrap">
          {columnValues.map((item, index) => {
            const fieldName = concatWithDot(name, `${index}`);
            return (
              <Grid key={fieldName} item xs={1}>
                <TotalSumInput
                  name={!noNeedName ? fieldName : ''}
                  id={!noNeedName ? fieldName : ''}
                  value={item}
                  look={LOOK.SUCCESS}
                  className={styles.totalRow}
                  disabled={disabled}
                  decimalScale={1}
                />
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </Grid>
  );
};
